


















import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { User } from "@/store/authentication/types";
import { authentication } from "@/store/authentication";
import i18n from "@/i18n";
import { FALLBACK_LOCALE } from "@/app.config";
const namespace: string = "authentication";

@Component
export default class Login extends Vue {
    @Action("loginAction", { namespace }) loginAction: any;
    @Action("azureLoginAction", { namespace }) azureLoginAction: any;
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;

    processingLogin = false;
    failedLogin = false;
    authUser: User = {
        email: "",
        password: ""
    };

    setLocale(): void {
        const languageCode: string = this.getCurrentUser.languageCode;
        i18n.locale = languageCode || FALLBACK_LOCALE;
    }

    onAzureSignIn() {
        this.azureLoginAction()
            .then((response: string) => {
                this.setLocale();
                this.$router.push("/");
            })
            .catch((reason: any) => {
                // TODO failed notification
                alert("login failed");
            });
    }
}
